import React from 'react';

const Demo = () => <h5>I am a component.</h5>;

export default Demo;
